// extracted by mini-css-extract-plugin
module.exports = {"block":"InputFilter_block__32l0t","inputFilter":"InputFilter_inputFilter__MlufJ","label":"InputFilter_label__2vu3R"};